import React from 'react'
import styles from './FormBoxPanel.less'
import { FormBoxContext } from './FormBoxContext'
import _ from 'common-tools/LodashHelper'

export class FormBoxPanel extends React.Component {
  static contextType = FormBoxContext

  render () {
    const { children, hide, name, debugMode: localDebugMode = false } = this.props
    const { sideEffects = {}, debugMode: contextDebugMode = false } = this.context

    if (hide === true) {
      return null
    }

    if (name) {
      const effects = _.get(sideEffects, name) || {}

      if (effects.hide) {
        return null
      }
    }

    let debugMode = contextDebugMode === true

    if (localDebugMode === true) {
      debugMode = true
    }

    if (debugMode) {
      return <div className={styles.formBoxPanelDebug}>
        <div className={styles.formBoxPanelDebugText}>Panel: {name || 'Not Named'}</div>
        {children}
      </div>
    } else {
      return <div className={styles.formBoxPanel}>
        {children}
      </div>
    }
  }
}
